"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    DRAFT: 'draft',
    SENT: 'sent',
};
//# sourceMappingURL=progressReportStatus.js.map